<template>
	<div class="handle-bar flex-center">
		<div v-if="$slots.icon"><slot name="icon"></slot></div>
		<div class="flex-grow"><slot></slot></div>
		<div v-if="$slots.handle" class="handle flex"><slot name="handle"></slot></div>
	</div>
</template>

<script>
	export default {
		name: 'handleBar'
	}
</script>

<style lang="stylus" scoped>
	.handle-bar {
		gap: .2rem;
		height: .76rem;
		padding: 0 .2rem;
		font-size: .26rem;

		.icon {
			font-size: .3rem;
		}

		.handle {
			gap: .15rem;
		}
	}
</style>
